<app-classify-form-wrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
></app-classify-form-wrapper>
